export default "__VITE_ASSET__BOWTZ80l__"